/**
 * 色调分离（对比 Photoshop 补全第一档缺口 阶段 1）。
 *
 * 每通道独立量化到 `levels` 级——跟 curvesLut/levelsLut 同一形状，256 项
 * LUT。`levels` 取 256 时输出恒等于输入（`round(round(v/255*255)/255*255)
 * = v`），拿这个当恒等参数，比 Photoshop 实际允许的上限 255 多留一档，
 * 换来"新建时画面不变"这个强制约定。
 */
export interface PosterizeParams {
  /** 每通道色阶数，2–256。 */
  readonly levels: number;
}

export const DEFAULT_POSTERIZE_PARAMS: PosterizeParams = { levels: 256 };

export function posterizeLut(levels: number): Uint8Array {
  const L = Math.max(2, Math.min(256, Math.round(levels)));
  const lut = new Uint8Array(256);
  for (let v = 0; v < 256; v++) {
    lut[v] = Math.round((Math.round((v / 255) * (L - 1)) / (L - 1)) * 255);
  }
  return lut;
}
